__turbopack_context__.v({
  "container": "uWyjya_container",
  "content": "uWyjya_content",
  "hideFirstBorder": "uWyjya_hideFirstBorder",
  "icon": "uWyjya_icon",
  "label": "uWyjya_label",
  "term": "uWyjya_term",
  "wrapper": "uWyjya_wrapper",
});
